<div class="p-relative">
    <div class="d-flex">
        <input #selected disabled class="border-none-outline-none w-90 bg-white">
        <button id="showDropdown" *ngIf="dropDownIcon == 'show'"  (click)="dropdownShowHide('hide')" class="border-none-outline-none fas fa-chevron-up bg-white" ></button> <button id="hideDropdown"
            (click)="dropdownShowHide('show')" *ngIf="dropDownIcon == 'hide'" class="border-none-outline-none fas fa-chevron-down bg-white"></button><br>
    </div>
    <div id="container" class="parent bg-white">
        <input #inputValue placeholder="Search..." class="w-100" (keyup)="filterData()">
        <ul id="select" [ngClass]="containerHeight > 350 ?'overflow-y':''"></ul>
    </div>
</div>